import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {MotosNotImplementedError} from '../../shared/Errors/MotosNotImplementedError.js'
import {FaqsPathNotImplementedError} from '../Errors/FaqsPathNotImplementedError.js'
import {GetStaticFaqsRequestValueObject} from '../ValueObjects/GetStaticFaqsRequestValueObject.js'

/**
 * @implements UseCase
 */
export class GetStaticFaqsSeoUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   * @param {Object} deps.log
   */
  constructor({config, httpSeoRepository}) {
    super()
    this._config = config
    this._hasStaticFaqsEnabled = this._config.get('seo').HAS_STATIC_FAQS_ENABLED
    this._httpSeoRepository = httpSeoRepository
    this._acceptedStaticFaqsPaths = this._config.get('seo').ACCEPTED_FAQS_PATHS || []
  }

  @tracer({metric: 'GetStaticFaqsSeoUseCase#execute'})
  @inlineError
  execute({path}) {
    if (!this._hasStaticFaqsEnabled) {
      return Promise.reject(MotosNotImplementedError.create('Motos use case not implemented'))
    }
    // Create the Request ValueObject first in case the path is not valid
    const getStaticFaqsRequestVO = GetStaticFaqsRequestValueObject.create({path})

    // Verify that the path is within the accepted paths
    if (!this._acceptedStaticFaqsPaths.some(acceptedPath => path.includes(acceptedPath))) {
      return Promise.reject(FaqsPathNotImplementedError.create('Faqs path not implemented'))
    }

    return this._httpSeoRepository.getStaticFaqs(getStaticFaqsRequestVO).then(([error, faqs]) => {
      if (error) {
        return Promise.reject(error)
      }
      return faqs.toJSON()
    })
  }
}
